import { useRelayEnvironment } from 'react-relay';
import { fetchQuery } from 'relay-runtime';

import { addressQuery } from '@/__generated__/addressQuery.graphql';
import { addressSggQuery } from '@/__generated__/addressSggQuery.graphql';
import { addressYmdgQuery } from '@/__generated__/addressYmdgQuery.graphql';
import { surveyAddress1, surveyAddress2, surveyAddressQuery } from '@/graphql/query/survey/address';

export const useLegalAddress = () => {
  const relayEnv = useRelayEnvironment();

  const getSido = (): Promise<string[]> => {
    return new Promise((resolve) => {
      fetchQuery<addressQuery>(relayEnv, surveyAddressQuery, {}).subscribe({
        next: (res) => {
          if (res.getSurveyAddress) {
            const sidoNames = res.getSurveyAddress
              .filter(({ sidoNm }) => !!sidoNm)
              .map(({ sidoNm }) => sidoNm || '')
              .sort();
            resolve(sidoNames);
          }
        }
      });
    });
  };

  const getSgg = (sidoNm: string): Promise<string[] | null> => {
    return new Promise((resolve) => {
      fetchQuery<addressSggQuery>(relayEnv, surveyAddress1, { sidoNm }).subscribe({
        next: (res) => {
          if (res.getSurveyAddress) {
            const sggNames = res.getSurveyAddress
              .filter(({ sggNm }) => !!sggNm)
              .map(({ sggNm }) => sggNm || '')
              .sort();
            resolve(sggNames.length > 0 ? sggNames : null);
          }
        }
      });
    });
  };

  const getYmdg = (sidoNm: string, sggNm: string): Promise<string[] | null> => {
    return new Promise((resolve) => {
      fetchQuery<addressYmdgQuery>(relayEnv, surveyAddress2, { sidoNm, sggNm }).subscribe({
        next: (res) => {
          if (res.getSurveyAddress) {
            const ymdgNames = res.getSurveyAddress
              .filter(({ ymdgNm }) => !!ymdgNm)
              .map(({ ymdgNm }) => ymdgNm || '')
              .sort();
            resolve(ymdgNames.length > 0 ? ymdgNames : null);
          }
        }
      });
    });
  };

  return {
    getSido,
    getSgg,
    getYmdg
  };
};
